export default function cssVariable() {
  const { documentElement } = document;
  let prevWidth = null;
  let prevHeight = null;

  const resizeHandler = () => {
    const { clientWidth, clientHeight } = documentElement;

    if (clientWidth !== prevWidth) {
      documentElement.style.setProperty('--jsClientWidth', `${clientWidth}px`);
      prevWidth = clientWidth;
    }
    if (clientHeight !== prevHeight) {
      documentElement.style.setProperty('--jsClientHeight', `${clientHeight}px`);
      prevHeight = clientHeight;
    }
  };

  window.addEventListener('resize', resizeHandler);
  resizeHandler();

  const widthVariableNodeList = document.querySelectorAll('[data-width-variable]');

  if (widthVariableNodeList.length === 0) return;

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const targetElement = entry.target;

      targetElement.style.setProperty('--jsContainerWidth', `${entry.contentRect.width}px`);
    });
  });
  widthVariableNodeList.forEach((element) => {
    resizeObserver.observe(element);
  });
}
